(function () {
    'use strict';

    const menuToggle = document.getElementById('header-nav-open-menu');
    const defaultNav = document.getElementById('org-navigation-default');
    const alertToggle = document.querySelector('.alert');

    const logo = document.getElementById('header-logo');
    const logoAlternate = document.getElementById('header-logo-alternate');

    if (menuToggle) {
        menuToggle.addEventListener('click', (e) => {
            e.preventDefault();
            const header = e.currentTarget.closest('.org-header');
            const headerDiv = document.querySelector('.vebego-header');

            // Toggle between .header-nav--active and .header-nav--closed on menuToggle
            if (menuToggle.classList.contains('header-nav--active')) {
                menuToggle.classList.remove('header-nav--active');
                menuToggle.classList.add('header-nav--closed');
            } else {
                menuToggle.classList.remove('header-nav--closed');
                menuToggle.classList.add('header-nav--active');
            }

            if (headerDiv) {
                headerDiv.classList.toggle('org-header--active');

                if (headerDiv.classList.contains('org-header--active')) {
                    headerDiv.classList.remove('org-header--closed');
                } else {
                    headerDiv.classList.add('org-header--closed');
                }

                document
                    .querySelector('body')
                    .classList.toggle('overflow-hidden');

                if (logoAlternate) {
                    logo.classList.toggle('hidden');
                    logoAlternate.classList.toggle('hidden');
                }

                setTimeout(function () {
                    if (
                        document
                            .querySelector('.nav-left')
                            .classList.contains('slide-in')
                    ) {
                        document
                            .querySelector('.nav-left')
                            .classList.remove('slide-in');
                    } else {
                        document
                            .querySelector('.nav-left')
                            .classList.add('slide-in');
                    }
                }, 1);
            }

            if (header) {
                header.classList.toggle('org-header--active');

                if (header.classList.contains('org-header--active')) {
                    header.classList.remove('org-header--closed');
                } else {
                    header.classList.add('org-header--closed');
                }
            }

            if (alertToggle) {
                alertToggle.classList.toggle('alert--active');
            }

            if (defaultNav) {
                header.classList.toggle('org-header--default-nav');
            }
        });
    }
})();
